module.exports = __webpack_public_path__ + "src/img/portrait.8eece.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/portrait.jpg
// module id = 108
// module chunks = 0